import jwtDecode from 'jwt-decode';

// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const ICONS = {
  dashboard: getIcon('eva:pie-chart-2-fill'),
  organisation: getIcon('material-symbols:corporate-fare'),
  masterData: getIcon('material-symbols:chart-data'),
};

const token = localStorage?.getItem('accessToken');
let decoded = {};

if (token) {
  decoded = jwtDecode(token);
} else {
  decoded.id = 0;
}

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
            // { title: 'dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },

            {
              title: 'Party List',
              icon: ICONS.organisation,
              path: PATH_DASHBOARD.party.party,
              permission: 'newCourierManagement',
            },
           
   
            {
              title: 'GST',
              icon: ICONS.organisation,
              path: PATH_DASHBOARD.general.app,
              permission: 'newCourierManagement',
            },
           
          
            {
              title: 'Income Tax',
              permission: 'salesManagement',
              path: PATH_DASHBOARD.incomeTax.incomeTax,
              icon: getIcon('icon-park-solid:sales-report'),
            },
        
            {
              title: 'TDS',
              permission: 'purchaseManagement',
              path: PATH_DASHBOARD.tds.tds,
              icon: getIcon('fa:cart-arrow-down'),
            },
            {
              title: 'Audit',
              permission: 'receiptManagement',
              path: PATH_DASHBOARD.audit.audit,
              icon: getIcon('carbon:piggy-bank'),
            },
            {
              title: 'ROC',
              permission: 'bankingManagement',
              path: PATH_DASHBOARD.roc.roc,
              icon: getIcon('bi:coin'),
            },
            // {
            //   title: 'PF',
            //   permission: 'bankingManagement',
            //   path: PATH_DASHBOARD.banking.root,
            //   icon: getIcon('bi:coin'),
            // },
            // {
            //   title: 'ESI',
            //   permission: 'bankingManagement',
            //   path: PATH_DASHBOARD.banking.root,
            //   icon: getIcon('bi:coin'),
            // },

            // {
            //   title: 'payment or expense',
            //   permission: 'paymentManagement',
            //   path: '/dashboard/payment',
            //   icon: getIcon('bi:cash-coin'),
            // },
       
         
    
      
       
          ]
        
  },
  
 
 
 
 
];

export default navConfig;
